/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2026 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

import { devtools } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

import { getShowProductStock, ProductStockDto } from '@/api-sdk';
import { GlobalComponentPropertiesTypes } from '@/types';
import { globalStorePropertiesStore } from './creators/creator.global-store-properties';

export type ProductStockState = Partial<GlobalComponentPropertiesTypes> & {
  productStock?: ProductStockDto;
  loading: boolean;
  error: boolean;
  getProductStock: () => Promise<void>;
  setConfig: (config: Partial<ProductStockState>) => void;
};

export const productStockStore = createStore<ProductStockState>()(
  devtools((set, get) => ({
    ...globalStorePropertiesStore,
    productStock: undefined,
    loading: false,
    error: false,
    getProductStock: async () => {
      const { locale, product } = get();
      if (!locale || !product) return;

      set(
        { loading: true, error: false },
        false,
        'SET_STATE: loading getProductStock',
      );
      try {
        const productStock = await getShowProductStock({
          code: product,
          params: {
            locale,
          },
        });

        set({ productStock }, false, 'SET_STATE: productStock getProductStock');
      } catch (error) {
        console.error(error);
        set({ error: true }, false, 'SET_STATE: error getProductStock');
      } finally {
        set({ loading: false }, false, 'SET_STATE: loading getProductStock');
      }
    },
    setConfig: config => {
      set({ ...config }, false, 'SET_STATE: setConfig');
    },
  })),
);
